module.exports = __webpack_public_path__ + "media/coffee-preferences/brew_method_cold_brew-42de4f4f.png";